<template>
  <section class="featured-boxes-area">
    <div class="container">
      <div class="featured-boxes-inner">
        <h3 style="padding-top: 20px; margin-bottom: -90px;">Access Channels</h3>
        <div class="row m-0">

          <div class="col-lg-4 col-sm-6 col-md-6 p-0">
            <div class="single-featured-box">
              <h5 class="card-header">Mobile App</h5>
              <img class="card-img-top" src="#" alt="Mobile Image">
              <div  class="card-body">
                <ul>
                  <li>Customer get receipt via SMS</li>
                  <li>Easy and Simple to use</li>
                  <li>Available on iOS and Android Store</li>
                </ul>
              </div>
            </div>
          </div>

         
          <div class="col-lg-4 col-sm-6 col-md-6 p-0">
            <div class="single-featured-box">
              <h5 class="card-header">Desktop App</h5>
              <img class="card-img-top" src="#" alt="Mobile Image">
              <div  class="card-body">
                Integrates into existing infrastructure without the need for new equipment.
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-sm-6 col-md-6 p-0">
            <div class="single-featured-box">
              <h5 class="card-header">Mobile Pos</h5>
              <img style="" class="card-img-top" src="assets/img/access-channels/pos.png" alt="Mobile Image">
              <div class="card-body">
                Can be used on the move and Supports Receipt Printing
              </div>
            </div>
          </div>
         
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data: () => {
    return {};
  },
  computed: {},
  filters: {}
};
</script>

<style scoped>
  img {
    width: 32%;
  }
</style>